import { createSolanaConnection } from "@/api/solanaRpc";

export function useSolanaConnection() {
  const connection = createSolanaConnection();
  return { connection };
}

export const solanaConnection = useSolanaConnection();
